import React from 'react'
import Navbar from "../components/navbar";
import faqHeader from "../assect/images/bg/dl_curvedimgs_info.png";
import AvailableProperties from "../components/availableproperties";
import Footer from "../components/footer";

// const leasingInfoObj = {
//     statement: "At Dimora Living, we manage our properties with pride and provide full-service experience for our residents, putting your comfort and needs above all else.",
//     items: [{
//         title: "Are there any requirements?",
//         subtitle: "",
//         detail:"Yes, each unit has a minimum credit score and minimum monthly income requirement."
//     }]
// }

const leasingInfoObj = {
    statement: "At Dimora Living, we manage our properties with pride and provide full-service experience for our residents, putting your comfort and needs above all else.",
    items: [{
        title: "",
        subtitle: "",
        detail: "All those interested must fill out our rental application, which includes a credit, background and eviction check.  Each adult who will live in the apartment must be on the application and the lease, and there is a $20 non-refundable fee per adult."
    }, {
        title: "",
        subtitle: "",
        detail: "Our minimum credit score is 620, and verified income must be at least 3x the monthly rent.  We allow lease guarantors."
    }, {
        title: "",
        subtitle: "",
        detail: "Our refundable security deposit is one month's rent."
    }, {
        title: "",
        subtitle: "",
        detail: "If you inquire about a particular apartment, we will email you a link to the application via our property management site, Hemlane."
    }]
}

export default function LeasingProcess() {
    const ListLeasingInfoItems = (arrInfo) => {

        return (
            <ul style={{ listStyle: "none", paddingLeft: 0 }} className="mt-lg-3">
                {
                    arrInfo.arrInfo.map((item, index) => (
                        <li key={index} style={{ marginInlineStart: "0" }}>
                            <p style={{ fontWeight: "bold", fontSize: "13pt" }}>{item.title}</p>
                            {item.subtitle.trim().length > 0 ? <span style={{ fontWeight: "bold", fontSize: "13pt" }}>{item.subtitle}</span> : null}
                            <p style={{ fontSize: "13pt" }}>{item.detail}</p>
                        </li>
                    ))
                }
            </ul>
        )
    }

    return (
        <div style={{ backgroundColor: "#f0eadd" }}>
            <Navbar navClass="defaultscroll sticky" logolight={true} menuClass="navigation-menu nav-right" />
            <div className="top-half top-half d-table w-100 pt-5">
                <section className="bg-half-116" style={{ backgroundImage: `url(${faqHeader})` }}>
                </section>
            </div>

            <section className="section-50 pb-0">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <p className="mb-md-5 mb-4 sub_heading">Leasing Information</p>
                        </div>
                        <div className="row justify-content-center">

                            <div className="col-xxl-6 col-lg-8 col-12">
                                <div className="section-title ms-lg-12 align-content-lg-end">
                                    <h6 className="mb-0" style={{ fontSize: "13pt", color: "#093b38" }}>{leasingInfoObj.statement}</h6>
                                    <ListLeasingInfoItems arrInfo={leasingInfoObj.items} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative avaliable_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <AvailableProperties />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}